import Payment from '@/classes/Payment';

export default (api, widgetJSApiInstance) => ({
  namespaced: true,
  state: {
    isModalShown: false,
    paymentMethods: [],
    loading: false,
  },
  mutations: {
    SET_IS_MODAL_SHOWN: (state, val) => { state.isModalShown = val; },
    SET_PAYMENT_METHODS: (state, val) => { state.paymentMethods = val; },
    SET_LOADING: (state, val) => { state.loading = val; },
  },
  actions: {
    fetchPaymentMethods({ commit, dispatch }) {
      commit('SET_LOADING', true);
      api.getPaymentMethods()
        .then((paymentMethods) => {
          const preparedPaymentMethods = paymentMethods.map((payment) => new Payment(payment))
            .filter((payment) => payment.strategy !== 'ton_connect');

          commit('SET_PAYMENT_METHODS', preparedPaymentMethods);
          dispatch('actualizeSelectedPaymentMethod', null, { root: true });
          widgetJSApiInstance.dispatchEvent('onPaymentMethodsLoaded', { preparedPaymentMethods });
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
  },
});
